// extracted by mini-css-extract-plugin
export default {"title":"style_title__RPmpS","date":"style_date__e88oP","content":"style_content__YiBAX"};